export const TOOTH_POSITIONS = {
    "18": "Structure of permanent maxillary right third molar tooth",
    "17": "Structure of permanent maxillary right second molar tooth",
    "16": "Structure of permanent maxillary right first molar tooth",
    "15": "Structure of permanent maxillary right second premolar tooth",
    "14": "Structure of permanent maxillary right first premolar tooth",
    "13": "Structure of permanent maxillary right canine tooth",
    "12": "Structure of permanent maxillary right lateral incisor tooth",
    "11": "Structure of permanent maxillary right central incisor tooth",
    "21": "Structure of permanent maxillary left central incisor tooth",
    "22": "Structure of permanent maxillary left lateral incisor tooth",
    "23": "Structure of permanent maxillary left canine tooth",
    "24": "Structure of permanent maxillary left first premolar tooth",
    "25": "Structure of permanent maxillary left second premolar tooth",
    "26": "Structure of permanent maxillary left first molar tooth",
    "27": "Structure of permanent maxillary left second molar tooth",
    "28": "Structure of permanent maxillary left third molar tooth",
    "31": "Structure of permanent mandibular left central incisor tooth",
    "32": "Structure of permanent mandibular left lateral incisor tooth",
    "33": "Structure of permanent mandibular left canine tooth",
    "34": "Structure of permanent mandibular left first premolar tooth",
    "35": "Structure of permanent mandibular left second premolar tooth",
    "36": "Structure of permanent mandibular left first molar tooth",
    "37": "Structure of permanent mandibular left second molar tooth",
    "38": "Structure of permanent mandibular left third molar tooth",
    "41": "Structure of permanent mandibular right central incisor tooth",
    "42": "Structure of permanent mandibular right lateral incisor tooth",
    "43": "Structure of permanent mandibular right canine tooth",
    "44": "Structure of permanent mandibular right first premolar tooth",
    "45": "Structure of permanent mandibular right second premolar tooth",
    "46": "Structure of permanent mandibular right first molar tooth",
    "47": "Structure of permanent mandibular right second molar tooth",
    "48": "Structure of permanent mandibular right third molar tooth",
    "55": "Structure of primary maxillary right second molar tooth",
    "54": "Structure of primary maxillary right first molar tooth",
    "53": "Structure of primary maxillary right canine tooth",
    "52": "Structure of primary maxillary right lateral incisor tooth",
    "51": "Structure of primary maxillary right central incisor tooth",
    "61": "Structure of primary maxillary left central incisor tooth",
    "62": "Structure of primary maxillary left lateral incisor tooth",
    "63": "Structure of primary maxillary left canine tooth",
    "64": "Structure of primary maxillary left first molar tooth",
    "65": "Structure of primary maxillary left second molar tooth",
    "71": "Structure of primary mandibular left central incisor tooth",
    "72": "Structure of primary mandibular left lateral incisor tooth",
    "73": "Structure of primary mandibular left canine tooth",
    "74": "Structure of primary mandibular left first molar tooth",
    "75": "Structure of primary mandibular left second molar tooth",
    "81": "Structure of primary mandibular right central incisor tooth",
    "82": "Structure of primary mandibular right lateral incisor tooth",
    "83": "Structure of primary mandibular right canine tooth",
    "84": "Structure of primary mandibular right first molar tooth",
    "85": "Structure of primary mandibular right second molar tooth",
};
